import request from '@/utils/http'
export function getHouseBanner () {
  return request({
    method: 'POST',
    url: '/rest/house/index/listBanner'
  })
}
export function getVideo () {
  return request({
    method: 'POST',
    url: '/rest/house/index/queryVideo'
  })
}
export function getNews () {
  return request({
    url: '/rest/house/index/queryGroupNews',
    method: 'POST'
  })
}
export function getVideoView () {
  return request({
    url: '/rest/house/index/queryMediaPerspective',
    method: 'POST'
  })
}



// WEBPACK FOOTER //
// ./src/api/house/index.js